import React, {Component} from 'react';

import Header from '../Header';
import Footer from '../Footer';
import Modals from '../Modals';

export default class LayoutFinish extends Component {

  render() {

    const {
      children
    } = this.props;

    return(
      <>
        <div className="site-content _finish">
          <div className="site-content__main">
            <Header />
            {children}
            <Footer container="_center" />
          </div>
          <div className="site-content__stub"> 
            <div className="site-content__stub__tablet-portrait">
              <div className="site-content__stub__logo">
                <a href="https://fitron.club/" target="_blank" rel="noopener noreferrer">
                  <img src={require('../../static/images/logo.svg')} alt=""/>
                </a>
              </div>
              <div className="site-content__stub__main-img">
                <img src={require('../../static/images/stub/768_hidden.gif')} alt=""/>
              </div>
              <div className="site-content__stub__text">
                <p>Пожалуйста, поверните планшет в&nbsp;горизонтальное положение</p>
              </div>
            </div>
            <div className="site-content__stub__mobile">
              <div className="site-content__stub__logo">
                <a href="https://fitron.club/" target="_blank" rel="noopener noreferrer">
                  <img src={require('../../static/images/logo.svg')} alt=""/>
                </a>
              </div>
              <div className="site-content__stub__main-img">
                <img src={require('../../static/images/stub/320_hidden.gif')} alt=""/>
              </div>
              <div className="site-content__stub__text">
                <p>Пожалуйста, откройте сервис с&nbsp;помощью планшета</p>
              </div>
            </div>
          </div>
        </div>
        <Modals />
      </>
    )
  }
}